import React from 'react';
import { Route, Switch } from 'react-router-dom';
import moment from 'moment';
import { interceptor } from './services/fecth-interceptor';
import {
  About,
  Contacts,
  EventsContainer,
  General,
  Home,
  Login,
  Logout,
  NewsContainer,
  Services
} from './containers/index';
import { NavigationBar } from './components/index';

moment.locale('pt-PT');

interceptor();

const navModel = {
  'brand': 'Planet',
  'leftLinks': [
    {
      'label': 'General',
      'link': '/general'
    },
    {
      'label': 'Home',
      'link': '/'
    },
    {
      'label': 'About',
      'link': '/about'
    }
  ],
  'rightLinks': [
    {
      'label': 'News',
      'link': '/news'
    },
    {
      'label': 'Events',
      'link': '/events'
    },
    {
      'label': 'Services',
      'link': '/services'
    },
    {
      'label': 'Contacts',
      'link': '/contacts'
    },
    {
      'label': 'Logout',
      'link': '/logout'
    }
  ]
};

export default (
  <div className="main-app">
    <NavigationBar
      brand={navModel.brand}
      navModel={navModel}
      handleLeftNavItemClick={() => {
      }}
      handleChangeLanguage={() => {
      }}
      handleRightNavItemClick={() => {
      }}/>
    <div className="main">
      <Switch>
        <Route exact path="/" component={Home}/>
        <Route path="/general" component={General}/>
        <Route path="/about" component={About}/>
        <Route path="/services" component={Services}/>
        <Route path="/news" component={NewsContainer}/>
        <Route path="/events" component={EventsContainer}/>
        <Route path="/contacts" component={Contacts}/>
        <Route path="/login" component={Login}/>
        <Route path="/logout" component={Logout}/>
      </Switch>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/routes.js